<template>
	<div>
		<div class = "cell-div">
			<van-cell-group>
			  <van-field v-model="accountNo" label-width="60" input-align="left" :disabled="accountInput" label="兑换码" placeholder="请输入兑换码或账号" maxlength="20"/>
			</van-cell-group>
		</div>
		<div class = "cell-div" v-if="isPhone">
			<van-cell-group>
			   <van-field v-model="phone" label-width="60" input-align="left" type="digit" label="手机号" :placeholder="phoneMsg" maxlength="11" :readonly="readonlyPhone"/>
			</van-cell-group>
		</div>
		<div v-show="isPhone && myPhone">
			<PhoneVerify :verifyType="verifyType" :mobile="phone" :verifyCount="verifyCount" @changeType="changeType" @back="aftVerify"></PhoneVerify>
			<Notes :hasPhone="phone != '' && phone.length == 11"></Notes>
		</div>
		<div class = "cell-div" v-show="showCode">
			<van-cell-group>
			<PayCode @setCode = "updateCode" :phone = "phone" :count="codeCount"></PayCode>
			</van-cell-group>
		</div>
		
		<div class = "btn-div">
			<van-button type="primary" color = "#4eab70" :disabled="verifyType == 1 && isPhone || isPhone && (phone.length != 11 || code.length !=6)" @click = "clickMerge()">确定</van-button>
		</div>
	</div>
</template>

<script>
	import PayCode from './PayCode'
	import PhoneVerify from '../phoneVerify/PhoneVerify.vue'
	import Notes from '../phoneVerify/Notes.vue'
	import { mergeAccount,getYuedongAccount,getMergeInfo } from '@/request/api';
	import {Field,Cell,CellGroup,Button,Notify} from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'Merge',
		computed: mapGetters(["sUserInfo"]),
		components: {
		      [Field.name]: Field,
		      [Cell.name]: Cell,
		      [CellGroup.name]: CellGroup,
		      [PayCode.name]: PayCode,
		      [Button.name]: Button,
		      [Notify.name]: Notify,
		      [PhoneVerify.name]: PhoneVerify,
		      [Notes.name]: Notes
		      
		 },
		data(){
			return {
				verifyCount:0,
				verifyType:0,
				showCode:false,
				showVerify:false,
				accountNo:'',
				accountInput:false,
				readonlyPhone:false,
				phone:'',
				code:'',
				codeCount:0,
				isPhone:false,
				myPhone:false,
				phoneMsg:''
			}
		},
		methods:{
			 ...mapMutations(['sSetUserInfo']),
			updateCode(code){
				this.code = code
			},
			changeType(type){
				this.verifyType = type
				if(type == 2){
					this.showCode = true
					this.codeCount++
				}else{
					this.showCode = false
					this.code = ''
					this.verifyCount ++
				}
			},
			aftVerify(){
				this.doRechargeMoney()
				this.verifyCount = 0
				this.verifyType = 0
				this.showCode = false
				this.showVerify = false
			},
			clickMerge(){
				if(!this.accountNo){
					Notify({ type: 'danger', message: '请输入兑换码或账号' });
					return
				}
				if(!this.accountInput){
					//先判断该账号是否需要绑定手机号
					// 去除所有空格
					let reg = /\s+/g
					this.accountNo = this.accountNo.replace(reg,'')
					getMergeInfo({
						accountNo:this.accountNo,	  
					}).then(res => {
						let currentAccount = res.currentAccountMobile;
						let inputAccount = res.inputAccountMobile;
						//当前账户和输入账户都未绑
						if(!currentAccount && !inputAccount){
							Notify({ type: 'warning', message: '请您绑定手机号码' });
							this.accountInput = true;
							this.phoneMsg = "请输入您的手机号";
							this.isPhone = true;
							this.myPhone = true;
							return;
						}else if(inputAccount){
							Notify({ type: 'warning', message: '请验证手机号码' });
							this.accountInput = true;
							this.phone = res.mobile;
							this.readonlyPhone = true
							this.showCode = true;
							this.isPhone = true;
							return;
						}else{
							Notify({ type: 'warning', message: '请验证手机号码' });
							this.accountInput = true;
							this.phone = res.mobile;
							this.readonlyPhone = true
							this.isPhone = true;
							this.myPhone = true;
							return;
						}
					}) ;
				}else{
					this.rechargeMoney();
				}
			},
			doRechargeMoney(){
				mergeAccount({
					accountNo:this.accountNo,	  
					mobile:	this.phone,	  
					code:this.code  
				}).then(res => {
					//查询用户信息
					this.getUserInfoForToken();
					this.verifyCount = 0
					this.verifyType = 0
					this.showVerify = false
					this.showCode = false
					this.accountInput = false
					this.isPhone = false
					this.myPhone = false
					this.accountNo = '';
					this.phone = '';
					this.code = '';
					this.phoneMsg = ';'
					Notify({ type: 'success', message: '合并成功' });					  
				}) 
			},
			rechargeMoney(){
				if(this.accountInput){
					if(this.code == '' || this.code.length != 6){
						Notify({ type: 'danger', message: '验证码格式错误' });
						return
					}
					if(this.phone == '' || this.phone.length != 11){
						Notify({ type: 'danger', message: '手机号格式错误' });
						return
					}
				}
				this.doRechargeMoney()
				
			},
			//通过token查询用户信息
			getUserInfoForToken(){
				  getYuedongAccount({
					  
				  }).then(res => {
					 this.sSetUserInfo(res);
				  }) 
			},
			
		}
	}
</script>

<style scoped>
	.cell-div {
		padding-top: 8px;
	}
	
	.cell-div .van-cell {
		/* padding: 15px 10px; */
	}
	
	.cell-div .van-field__label {
		color: #2d2d2d;
		font-size: 15px;
	}
	
	.btn-div {
		padding: 18px;
		margin-top: 80px;
	}
	
	.btn-div>button {
		width: 100%;
		height: 50px;
		border-radius: 4px;
	}
	
	.btn-div .van-button__text {
		font-size: 15px;
	}
</style>
